import { Workspace_Configuration } from "graphql/generated/graphql";

export const actions = {
    START_FETCH_WORKSPACE_SETTINGS: "START_FETCH_WORKSPACE_SETTINGS",
    FETCH_WORKSPACE_SETTINGS_SUCCESSFUL: "FETCH_WORKSPACE_SETTINGS_SUCCESSFUL",
    FETCH_WORKSPACE_SETTINGS_FAILED: "FETCH_WORKSPACE_SETTINGS_FAILED",
    SET_WORKSPACE_SETTING: "SET_WORKSPACE_SETTING",
    SET_WORKSPACE_SETTING_SUCCESS: "SET_WORKSPACE_SETTING_SUCCESS",
    SET_WORKSPACE_SETTING_FAILED: "SET_WORKSPACE_SETTING_FAILED",
} as const;

export const initialState: {
    listingFetching: boolean;
    settingsList: Workspace_Configuration[];
} = {
    listingFetching: false,
    settingsList: [],
};

export default (
    state = initialState,
    {
        type,
        settingsList,
        settingSingle,
        params,
    }: {
        type: string;
        settingsList: Workspace_Configuration[];
        settingSingle: Workspace_Configuration;
        params: {
            query: string;
            variables: {
                [key: string]: any;
            };
        };
    }
) => {
    switch (type) {
        case actions.START_FETCH_WORKSPACE_SETTINGS: {
            return {
                ...state,
                listingFetching: true,
            };
        }

        case actions.FETCH_WORKSPACE_SETTINGS_SUCCESSFUL: {
            return {
                ...state,
                listingFetching: false,
                settingsList,
            };
        }

        case actions.FETCH_WORKSPACE_SETTINGS_FAILED: {
            return {
                ...state,
                listingFetching: false,
                settingsList,
            };
        }

        // update the settingsList with the new value that has just been set
        case actions.SET_WORKSPACE_SETTING_SUCCESS: {
            return {
                ...state,
                settingsList: state.settingsList.map((setting) =>
                    setting.id === settingSingle.id ? settingSingle : setting
                ),
            };
        }

        default:
            return state;
    }
};
